import React from "react";
import classNames from "classnames";
// Styles
import "./style.scss";

const OptionToggle = ({ title, options = [], selected = { value: "" }, onChange = () => {} }) => {
  return (
    <div className="option-toggle">
      <h3>{title}</h3>
      <div className="track-wrapper">
        {options.map((option, index) => (
          <div
            key={index}
            className={classNames("option", {
              active: option.value === selected.value
            })}
            onClick={() => onChange(option)}
          >
            <p>{option.value}</p>
            <small>{option.info}</small>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OptionToggle;
